/** Approvals sahifasi lug'ati (ru). */
export default {
  title: "Согласования",
  subtitle: "{{scope}} · {{count}} ожидают вашего решения",
  scope: { all: "Все филиалы", myBranch: "Мой филиал" },
  history: "История",
  backToPending: "К ожидающим",
  kind: { hire: "Найм", transfer: "Передача", expense: "Расход", bonus: "Бонус" },
  kinds: { hire: "Наймы", transfer: "Передачи", expense: "Расходы", bonus: "Бонусы" },
  hireInfo: "Найм учитывается в отчётах, KPI и бонусах только после согласования.",
  loadFailed: "Не удалось загрузить согласования.",
  empty: {
    history: "Решений пока нет",
    historyDesc: "Здесь появятся рассмотренные запросы.",
    pending: "Нет ожидающих: {{kind}}",
    pendingDesc: "Новые запросы появляются здесь в реальном времени.",
  },
  pagination: "запросов",
  recent: { title: "Недавние решения", none: "Решений пока нет", by: "{{who}}" },
  toast: {
    approved: "Одобрено: {{name}}",
    rejected: "Отклонено: {{name}}",
    alreadyDecided: "Уже решено или изменено",
    listRefreshed: "Список обновлён.",
    saveFailed: "Не удалось сохранить решение",
    checkConnection: "Проверьте соединение и попробуйте снова.",
  },
  columns: {
    driver: "Водитель",
    recruiter: "Рекрутер",
    carrierJob: "Перевозчик / Вакансия",
    startDate: "Дата выхода",
    evidence: "Подтверждение",
    submitted: "Отправлено",
    decision: "Решение",
    actions: "Действия",
    fromTo: "От кого → Кому",
    requestedBy: "Запросил",
    note: "Заметка",
    branch: "Филиал",
  },
  noConfirmation: "Нет подтверждения перевозчика",
  pool: "общий пул",
  markedBy: "отметил {{who}}",
  approve: {
    title: "Одобрить {{what}}",
    hireHint: "После одобрения найм учитывается в отчётах, KPI и бонусе рекрутера. Проверки удержания (30/60/90 дней) планируются автоматически.",
    note: "Заметка (необязательно)",
    notePlaceholder: "Подтверждено письмом перевозчика…",
    fee: "Оплата от {{carrier}} ($)",
    feeHint: "Сколько перевозчик платит за этого водителя. Позже можно изменить в Бюджет → Оплаты перевозчиков; поступление денег фиксируется там.",
  },
  reject: {
    title: "Отклонить {{what}}",
    reason: "Причина",
    chooseReason: "Выберите причину…",
    reasonPlaceholder: "Почему отклоняется?",
    returnTo: "Вернуть водителя в статус",
    comment: "Комментарий рекрутеру",
    commentPlaceholder: "Попросите перевозчика подтвердить дату выхода по email",
    footnote: "Рекрутер получит уведомление. Ничего не удаляется; решение записывается в журнал.",
    rejectHire: "Отклонить найм",
    reasonRequired: "Укажите причину.",
  },
};
